import { createApiRef } from '@backstage/core-plugin-api';
import type {
  Assessment,
  AssessmentDetail,
  AssessmentKind,
  AssessmentResults,
  AssessmentStatus,
  ChecklistItem,
  ChecklistTick,
  MaturityDescription,
  MaturityLevel,
  Pillar,
  PillarLevel,
  Question,
  Response,
  SeriesSummary,
  SeriesTrend,
} from '@internal/backstage-plugin-ai-gra-common';

export interface AiGraApi {
  getPillars(): Promise<Pillar[]>;
  getMaturityDescriptions(): Promise<MaturityDescription[]>;
  getChecklistItems(): Promise<ChecklistItem[]>;
  getQuestions(): Promise<Question[]>;

  listAssessments(kind?: AssessmentKind): Promise<Assessment[]>;
  createAssessment(data: {
    kind: AssessmentKind;
    organisationName: string;
  }): Promise<Assessment>;
  getAssessment(id: string): Promise<AssessmentDetail>;
  patchAssessment(
    id: string,
    data: { organisationName?: string; status?: AssessmentStatus },
  ): Promise<Assessment>;
  deleteAssessment(id: string): Promise<void>;

  upsertResponse(
    assessmentId: string,
    questionId: string,
    value: MaturityLevel,
  ): Promise<Response>;
  getAssessmentResults(assessmentId: string): Promise<AssessmentResults>;

  setPillarLevel(
    assessmentId: string,
    pillarId: string,
    level: MaturityLevel,
  ): Promise<PillarLevel>;
  setChecklistTick(
    assessmentId: string,
    itemId: string,
    checked: boolean,
  ): Promise<ChecklistTick | { checked: false }>;

  listSeries(kind?: AssessmentKind): Promise<SeriesSummary[]>;
  getSeriesTrend(fingerprint: string): Promise<SeriesTrend>;
}

export const aiGraApiRef = createApiRef<AiGraApi>({
  id: 'plugin.ai-gra.service',
});
